import { DesignSystem } from "../design-system.js";
import { Card } from "./card.js";
import { styles } from "./card.styles.js";
import { template } from "./card.template.js";
/**
 *
 * @public
 * @remarks
 * HTML Element: <fabric-card>
 */
export const definition = Card.compose({
    name: `${DesignSystem.prefix}-card`,
    template,
    styles,
    shadowOptions: {
        mode: DesignSystem.shadowRootMode
    }
});
//# sourceMappingURL=card.definition.js.map